import { useSelector } from 'react-redux';
import { consentKeyMap } from '../consentService';
import { APP, WEB } from '../../constants/AppConstants';


export function useUserNotificationConsent() {
  const { userNotificationConsentDetails, loading, success, error } =
    useSelector((state) => state.BROTHERPLUS.getUserNotificationConsentDetails);

  const {
    [consentKeyMap[WEB]]: emailConsent,
    [consentKeyMap[APP]]: inAppConsent,
  } = userNotificationConsentDetails || {};

  return {
    userNotificationConsentDetails,
    emailConsent,
    inAppConsent,
    loading,
    success,
    error,
  };
}